<template>
  <div class="contents userInfo">
    <!-- <div class="title flexB">
      <h2>회원 정보</h2>
    </div> -->
    <div class="box one">
      <h2>회원 정보</h2>

      <div class="inputBox">
        <div class="flex">
          <p>권한</p>
          <el-select v-model="isAdmin">
            <el-option label="관리자" :value="true"> </el-option>
            <el-option label="일반" :value="false"> </el-option>
          </el-select>

          <!-- <label
            ><input
              type="radio"
              name="Role"
              :value="true"
              v-model="isAdmin"
            />관리자
          </label>
          <label
            ><input
              type="radio"
              name="Role"
              :value="false"
              v-model="isAdmin"
            />일반
          </label> -->
        </div>

        <div class="flex">
          <p>닉네임</p>
          <el-input v-model="nickname"></el-input>
        </div>
        <div class="flex">
          <p>이메일</p>
          <el-input v-model="email" disabled></el-input>
        </div>
        <div class="flex">
          <p>레벨</p>
          <el-select v-model="level">
            <el-option label="Level 1" :value="'1'"> </el-option>
            <el-option label="Level 2" :value="'2'"> </el-option>
            <el-option label="Level 3" :value="'3'"> </el-option>
            <el-option label="Level 4" :value="'4'"> </el-option>
            <el-option label="Level 5" :value="'5'"> </el-option>
            <el-option label="Level 6" :value="'6'"> </el-option>
            <el-option label="Level 7" :value="'7'"> </el-option>
            <el-option label="Level 8" :value="'8'"> </el-option>
            <el-option label="Level 9" :value="'9'"> </el-option>
            <el-option label="Level 10" :value="'10'"> </el-option>
          </el-select>
        </div>
        <div class="flex">
          <p>레벨 테스트 상태</p>
          <el-input
            :value="getLevelTestStatusLabel(levelTestStatus)"
            disabled
          ></el-input>
        </div>
        <div class="flex">
          <p>레벨 테스트 결과</p>
          <el-input
            :value="getLevelTestOutcomeLabel(levelTestOutcome)"
            disabled
          ></el-input>
        </div>
        <div class="flex" v-if="levelTestNextRetakeAt">
          <p>다음 재응시 가능일</p>
          <el-input v-model="levelTestNextRetakeAt" disabled />
        </div>
        <div class="flex">
          <p>가입경로</p>
          <el-input
            :value="getAuthProviderLabel(authProvider)"
            disabled
          ></el-input>
        </div>
        <div class="flex">
          <p>가입목적</p>
          <el-input :value="getPurposeLabel(purpose)" disabled></el-input>
        </div>

        <div class="flex">
          <p>관심사</p>
          <el-input v-model="topicsString" disabled></el-input>
        </div>
        <div class="flex">
          <p>이용 약관</p>
          <el-select v-model="userTerms" disabled>
            <el-option label="동의" :value="true"> </el-option>
            <el-option label="미동의" :value="false"> </el-option>
          </el-select>
        </div>
        <div class="flex">
          <p>개인정보처리방침</p>
          <el-select v-model="privacyPolicy" disabled>
            <el-option label="동의" :value="true"> </el-option>
            <el-option label="미동의" :value="false"> </el-option>
          </el-select>
        </div>
        <div class="flex">
          <p>가입일</p>
          <el-input v-model="createdAt" disabled></el-input>
        </div>
        <div class="flex" v-if="dropedAt">
          <p>탈퇴일</p>
          <el-input v-model="dropedAt" disabled></el-input>
        </div>
      </div>

      <div class="buttonWrap">
        <button class="basic" @click="submit" :disabled="isWithdrawn">
          수정
        </button>
        <button
          v-if="!isWithdrawn"
          class="line"
          type="button"
          @click="handleDelete"
        >
          탈퇴 처리
        </button>
      </div>
    </div>

    <div ref="subscriptionSection" class="box one mhu">
      <h2>구독 정보</h2>
      <div class="inputBox">
        <div class="flex">
          <p>구독 상태</p>
          <el-input :value="subscriptionLabel" disabled></el-input>
        </div>
        <!-- <div class="flex">
          <p>자동갱신</p>
          <el-input :value="autoRenewingLabel" disabled></el-input>
        </div> -->
        <div class="flex">
          <p>구독 만료일</p>
          <el-input :value="subscribeDue || '-'" disabled></el-input>
        </div>
        <div
          class="flex"
          v-if="
            latestPayment.productId ||
            latestPayment.productID ||
            latestPayment.basePlanId ||
            latestPayment.lineItemProductId ||
            latestPayment.offerId
          "
        >
          <p>상품 ID</p>
          <el-input
            :value="
              latestPayment.offerId ||
              latestPayment.basePlanId ||
              latestPayment.productId ||
              latestPayment.productID ||
              latestPayment.lineItemProductId ||
              '-'
            "
            disabled
          ></el-input>
        </div>
        <div class="flex" v-if="latestPayment.platform">
          <p>결제 플랫폼</p>
          <el-input :value="latestPayment.platform" disabled></el-input>
        </div>
        <div class="flex" v-if="latestPayment.status">
          <p>최근 결제 상태</p>
          <el-input
            :value="
              getPaymentStatusLabel(getEffectivePaymentStatus(latestPayment))
            "
            disabled
          ></el-input>
        </div>
      </div>

      <h3 class="sectionSubTitle">결제 · 구독 내역</h3>
      <div v-if="paymentLoading" style="padding: 10px 0">불러오는 중...</div>
      <div v-else-if="paymentLoadError" class="paymentNotice">
        {{ paymentLoadError }}
      </div>
      <div v-else-if="paymentList.length === 0" style="padding: 10px 0">
        결제 내역이 없습니다.
      </div>
      <div v-else class="logTableWrap">
        <table class="logTable paymentTable">
          <colgroup>
            <col style="width: 10%" />
            <col style="width: 30%" />
            <col style="width: 12%" />
            <col style="width: 8%" />
            <col style="width: 20%" />
            <col style="width: 20%" />
          </colgroup>
          <thead>
            <tr>
              <th>번호</th>
              <th>구독상품</th>
              <th>플랫폼</th>
              <th>상태</th>
              <th>만료일</th>
              <th>등록일</th>
              <!-- <th>수정일</th> -->
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(payment, index) in paginatedPaymentList"
              :key="payment._id || index"
            >
              <td>
                {{
                  paymentList.length -
                  ((paymentCurrentPage - 1) * paymentPageSize + index)
                }}
              </td>
              <td>
                <template v-if="payment.platform === 'android'">
                  {{ getAndroidProductLabel(payment) }}
                </template>
                <template v-else-if="payment.platform === 'ios'">
                  {{ getIosProductLabel(payment) }}
                  {{ getSubscriptionTypeLabel(payment) }}
                </template>
                <template v-else>-</template>
              </td>
              <td>{{ payment.platform }}</td>
              <td>
                {{ getPaymentStatusLabel(getEffectivePaymentStatus(payment)) }}
              </td>
              <td>{{ formatPaymentDate(payment.expiryTimeMillis) }}</td>
              <td>{{ formatPaymentDate(payment.createdAt) }}</td>
              <!-- <td>{{ formatPaymentDate(payment.updateAt) }}</td> -->
            </tr>
          </tbody>
        </table>
        <div class="pagination" v-if="paymentList.length > 0">
          <el-pagination
            layout="prev, pager, next"
            :total="paymentList.length"
            :page-size="paymentPageSize"
            :current-page.sync="paymentCurrentPage"
          ></el-pagination>
        </div>
      </div>
    </div>

    <div class="box one mhu">
      <h2>회원 활동 기록</h2>

      <div v-if="logList.length === 0" style="padding: 10px 0">
        기록이 없습니다.
      </div>

      <div v-else class="logTableWrap">
        <table class="logTable">
          <colgroup>
            <col style="width: 12%" />
            <col style="width: 24%" />
            <col style="width: 24%" />
            <col style="width: 15%" />
            <col style="width: 10%" />
            <col style="width: 15%" />
          </colgroup>
          <thead>
            <tr>
              <th>구분</th>
              <th>시간</th>
              <th>디바이스 ID</th>
              <th>사용시간</th>
              <th>플랫폼</th>
              <th>국가</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(log, index) in paginatedLogList" :key="index">
              <td>{{ log.action === "enter" ? "앱 진입" : "앱 종료" }}</td>
              <td>
                {{
                  log.action === "enter"
                    ? moment(log.timestamp).format("YYYY.MM.DD HH:mm:ss")
                    : "-"
                }}
              </td>
              <td>{{ log.deviceId || "-" }}</td>
              <td>{{ log.duration ? `${log.duration}초 사용` : "-" }}</td>
              <td>{{ log.platform ? `${log.platform}` : "-" }}</td>
              <td>{{ getCountryName(log.countryCode) }}</td>
            </tr>
          </tbody>
        </table>
        <div class="pagination" v-if="paginatedLogList.length > 0">
          <el-pagination
            layout="prev, pager, next"
            :total="logList.length"
            :page-size="pageSize"
            :current-page.sync="logCurrentPage"
          ></el-pagination>
        </div>
      </div>
    </div>

    <div class="buttonWrap">
      <router-link :to="backLink">
        <span class="material-icons-round"> keyboard_backspace </span
        >목록</router-link
      >
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  fetchUserDetails,
  fetchUserLogs,
  fetchUserPayments,
  updateUserDetails,
  removeUser,
} from "@/api/admin";
import { format } from "@/mixins/format";
import {
  getAndroidProductLabel,
  getIosProductLabel,
  // getAutoRenewingLabel,
  getEffectivePaymentStatus,
  // getPaymentPlatformLabel,
  getPaymentStatusLabel,
  getSubscriptionTypeLabel,
} from "@/utils/paymentDisplay";
const countryDisplayNames =
  typeof Intl !== "undefined" && typeof Intl.DisplayNames === "function"
    ? new Intl.DisplayNames(["ko"], { type: "region" })
    : null;
export default {
  mixins: [format],
  name: "userDetail",

  data() {
    return {
      moment: moment,
      userId: "",
      isAdmin: false,
      nickname: "",
      isMember: false,
      subscriptionLabel: "미구독",
      subscriptionStatus: "",
      isSubscriptionActive: false,
      autoRenewing: null,
      subscribeDue: "",
      paymentList: [],
      paymentLoading: false,
      paymentLoadError: "",
      paymentCurrentPage: 1,
      paymentPageSize: 10,
      email: "",
      authProvider: "",
      level: "",
      levelTestStatus: "",
      levelTestOutcome: "",
      levelTestNextRetakeAt: "",
      purpose: "",
      topics: [],
      createdAt: "",
      updatedAt: "",
      dropedAt: "",
      userTerms: false,
      privacyPolicy: false,
      isNodata: false,
      total: 0,
      pageSize: 10,
      logCurrentPage: 1,
      logList: [],

      adminOption: [
        {
          value: true,
          label: "관리자",
        },
        {
          value: false,
          label: "일반",
        },
      ],
    };
  },
  mounted() {
    this.userId = this.$route.query.id;
    const navbarIndex = this.$route.query.from === "subscriptions" ? "8" : "1";
    this.$store.dispatch("SET_NAVBAR", navbarIndex);
    this.getUserDetail();
    this.getUserPayments();
    this.getUserLogs();
    this.$nextTick(() => {
      if (this.$route.query.tab === "subscription") {
        this.$refs.subscriptionSection?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  },
  computed: {
    backLink() {
      return this.$route.query.from === "subscriptions"
        ? "/admin/subscriptions/manage?page=1"
        : "/admin/users";
    },
    // autoRenewingLabel() {
    //   return getAutoRenewingLabel(this.autoRenewing);
    // },
    sortedPaymentList() {
      return [...this.paymentList].sort((a, b) => {
        const aExpired = getEffectivePaymentStatus(a) === "expired";
        const bExpired = getEffectivePaymentStatus(b) === "expired";

        if (aExpired !== bExpired) {
          return aExpired ? 1 : -1;
        }

        const aExpiry = Number(a.expiryTimeMillis || 0);
        const bExpiry = Number(b.expiryTimeMillis || 0);
        return bExpiry - aExpiry;
      });
    },
    latestPayment() {
      return this.sortedPaymentList[0] || {};
    },
    topicsString: {
      get() {
        return this.topics.map((topic) => this.getTopicLabel(topic)).join(", ");
      },
      set(value) {
        this.topics = value.split(",").map((topic) => topic.trim()); // 문자열 → 배열 변환
      },
    },
    paginatedLogList() {
      const start = (this.logCurrentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.logList.slice(start, end);
    },
    paginatedPaymentList() {
      const start = (this.paymentCurrentPage - 1) * this.paymentPageSize;
      const end = start + this.paymentPageSize;
      return this.sortedPaymentList.slice(start, end);
    },
    isWithdrawn() {
      return this.authProvider === "withdrawn" || Boolean(this.dropedAt);
    },
  },
  methods: {
    dateFormat(date) {
      return moment(date).format("YYYY.MM.DD HH:mm"); // 배열 → 문자열 변환
    },
    getCountryName(countryCode) {
      if (!countryCode) {
        return "-";
      }

      const normalizedCode = String(countryCode).trim().toUpperCase();

      if (!normalizedCode || !countryDisplayNames) {
        return normalizedCode || "-";
      }

      try {
        return countryDisplayNames.of(normalizedCode) || normalizedCode;
      } catch (error) {
        return normalizedCode;
      }
    },
    getPurposeLabel(purpose) {
      const purposeMap = {
        travel: "여행 또는 유학",
        conversation: "외국인과 대화",
        self_improvement: "자기계발",
        employment: "취업 준비",
        kpop: "한국 문화",
      };

      return purposeMap[purpose] || purpose || "-";
    },
    getTopicLabel(topic) {
      const topicMap = {
        travel: "여행",
        social: "사교",
        career: "커리어",
        romance: "연애",
        shopping: "쇼핑",
        animals: "동물",
        food: "음식",
        culture: "문화",
        sports: "스포츠",
      };

      return topicMap[topic] || topic || "-";
    },
    getAuthProviderLabel(authProvider) {
      const authProviderMap = {
        apple: "애플",
        google: "구글",
        email: "이메일",
        withdrawn: "-",
      };

      return authProviderMap[authProvider] || authProvider || "-";
    },
    getLevelTestStatusLabel(status) {
      const statusMap = {
        draft: "초안",
        in_progress: "진행 중",
        submitted: "제출 완료",
        under_review: "검토 중",
        finalized: "확정 완료",
      };
      return statusMap[status] || status || "-";
    },
    getLevelTestOutcomeLabel(outcome) {
      const outcomeMap = {
        pending: "대기",
        passed: "합격",
        failed: "불합격",
        needs_retake: "재응시",
      };
      return outcomeMap[outcome] || outcome || "-";
    },
    getAndroidProductLabel,
    getIosProductLabel,
    getPaymentStatusLabel,
    getEffectivePaymentStatus,
    getSubscriptionTypeLabel,
    // getPaymentPlatformLabel,
    // getAutoRenewingLabel,

    formatPaymentDate(value) {
      if (value === undefined || value === null || value === "") {
        return "-";
      }

      const millis = Number(value);
      if (Number.isFinite(millis) && millis > 0) {
        return moment(millis).format("YYYY.MM.DD HH:mm");
      }

      return moment(value).isValid()
        ? moment(value).format("YYYY.MM.DD HH:mm")
        : "-";
    },
    getUserDetail() {
      fetchUserDetails(this.userId).then((res) => {
        console.log("fetchUserDetails", res);
        if (res.data.status == 200) {
          const data = res.data.data || {};
          this.isAdmin = data.isAdmin;
          this.email = data.email;
          this.nickname = data.nickname;
          this.isMember = data.isMember;
          this.subscriptionLabel =
            data.subscriptionLabel || (data.isMember ? "구독중" : "미구독");
          this.subscriptionStatus = data.subscriptionStatus || "";
          this.isSubscriptionActive = Boolean(data.isSubscriptionActive);
          this.autoRenewing = data.autoRenewing;
          this.subscribeDue = data.subscribeDue
            ? moment(data.subscribeDue).format("YYYY.MM.DD HH:mm")
            : "";
          this.authProvider = data.authProvider;
          this.level = String(data.level ?? "1");
          this.levelTestStatus = data.levelTestStatus;
          this.levelTestOutcome = data.levelTestOutcome;
          this.levelTestNextRetakeAt = data.levelTestNextRetakeAt
            ? moment(data.levelTestNextRetakeAt).format("YYYY.MM.DD HH:mm")
            : "";
          this.purpose = data.purpose;
          this.topics = data.topics;
          this.userTerms = data.userTerms;
          this.privacyPolicy = data.privacyPolicy;
          this.createdAt = moment(data.createdAt).format("YYYY.MM.DD HH:mm");
          this.updatedAt = moment(data.updatedAt).format("YYYY.MM.DD HH:mm");
          this.dropedAt = data.dropedAt
            ? moment(data.dropedAt).format("YYYY.MM.DD HH:mm")
            : "";
        }
      });
    },
    getUserPayments() {
      this.paymentLoading = true;
      this.paymentLoadError = "";

      fetchUserPayments(this.userId)
        .then((res) => {
          const payload = res.data || {};
          console.log("fetchUserPayments", payload);
          if (payload.status === 200) {
            this.paymentList = Array.isArray(payload.data) ? payload.data : [];
            return;
          }
          this.paymentLoadError =
            payload.message || "결제 내역을 불러오지 못했습니다.";
        })
        .catch((err) => {
          if (err.response?.status === 404) {
            this.paymentLoadError =
              "결제 내역 API가 서버에 아직 배포되지 않았습니다.";
            return;
          }
          this.paymentLoadError =
            err.response?.data?.message ||
            err.message ||
            "결제 내역을 불러오지 못했습니다.";
        })
        .finally(() => {
          this.paymentLoading = false;
        });
    },
    getUserLogs() {
      fetchUserLogs(this.userId)
        .then((res) => {
          if (res.data.status === 200) {
            this.logList = res.data.data;
          }
        })
        .catch(() => {});
    },
    submit() {
      const trimmedNickname = String(this.nickname || "").trim();

      if (trimmedNickname.length < 2 || trimmedNickname.length > 12) {
        return alert("닉네임은 2자 이상 12자 이하로 입력해주세요.");
      }

      const data = {
        userId: this.userId,
        isAdmin: this.isAdmin,
        nickname: trimmedNickname,
      };

      updateUserDetails(data)
        .then((res) => {
          if (res.data.status == 200) {
            alert("회원 정보가 수정 되었습니다.");
            this.$router.push("/admin/users");
            return;
          }
          alert(res.data.message || "회원 정보 수정에 실패했습니다.");
        })
        .catch((err) => {
          const message =
            err.response?.data?.message ||
            err.message ||
            "회원 정보 수정에 실패했습니다.";
          alert(message);
        });
    },
    handleDelete() {
      if (!this.userId) {
        return alert("회원 정보를 불러오지 못했습니다.");
      }
      if (this.isWithdrawn) {
        return alert("이미 탈퇴 처리된 회원입니다.");
      }

      const confirmed = confirm(
        "해당 회원을 탈퇴 처리하시겠습니까?\n탈퇴 후 개인정보가 삭제되며 복구할 수 없습니다."
      );
      if (!confirmed) {
        return;
      }

      removeUser({ userId: this.userId })
        .then((res) => {
          const payload = res.data || {};
          if (payload.status == 200) {
            alert("탈퇴 처리가 완료되었습니다.");
            this.$router.push("/admin/users");
            return;
          }
          alert(payload.message || "탈퇴 처리에 실패했습니다.");
        })
        .catch((err) => {
          const message =
            err.response?.data?.message ||
            err.message ||
            "탈퇴 처리에 실패했습니다.";
          alert(message);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.admin .userInfo .flex p {
  width: 150px !important;
}
.logTableWrap {
  overflow-x: auto;
}

.logTable {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.logTable th,
.logTable td {
  border: 1px solid #ddd;
  padding: 8px 10px;
  text-align: center;
}

.logTable th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.sectionSubTitle {
  margin: 24px 0 12px;
  font-size: 16px;
  font-weight: 700;
}

.paymentNotice {
  padding: 10px 0;
  color: #888;
}
</style>
